import React from 'react';
import { ButtonProps, Pressable, Text, ColorValue, View } from 'react-native';
import useStyles from '../../hooks/styles-hook';
import { NamedStyles } from 'react-dom';
import { StylesHelper } from '../../models/helpers/stylesHelper';

export enum PillButtonVariant {
  normal,
  outline,
}

interface PillButtonProps extends ButtonProps {
  icon?: React.ReactNode;
  style?: NamedStyles<any>;
  textStyle?: NamedStyles<any>;
  variant?: PillButtonVariant;
  outlineButtonColor?: ColorValue;
  noPadding?: boolean;
}

const PillButton = (props: PillButtonProps) => {
  const styles = useStyles((section) => section.pillButton);
  const buttonStyle = props.variant === PillButtonVariant.outline ? styles.button.outlineButton : styles.button.main;

  return (
    <Pressable
      {...props}
      onPressIn={(event) => {
        event.stopPropagation?.();
        (props as any).onPressIn?.(event);
      }}
      onPress={(event) => {
        event.stopPropagation?.();
        props.onPress?.(event);
      }}
      style={[props.noPadding ? undefined : { ...StylesHelper.padding(16) }]}
    >
      <View
        style={[
          buttonStyle,
          props.style ?? {},
          props.variant === PillButtonVariant.outline && props.outlineButtonColor ? { borderColor: props.outlineButtonColor } : {},
          { ...StylesHelper.padding(8, 12) },
        ]}
      >
        {props.icon}
        <Text
          style={[
            styles.text.main,
            props.variant === PillButtonVariant.outline && props.outlineButtonColor ? { color: props.outlineButtonColor } : {},
            props.icon ? { marginLeft: 4 } : {},
            props.textStyle ?? {},
          ]}
        >
          {props.title}
        </Text>
      </View>
    </Pressable>
  );
};

export default PillButton;
